import { Delete as DeleteIcon } from '@mui/icons-material';
import { IconButton, type IconButtonProps } from '@mui/material';

type DeleteButtonProps = Omit<IconButtonProps, 'edge'>;

const DeleteButton = (props: DeleteButtonProps) => (
  <IconButton edge="end" size="small" color="error" {...props}>
    <DeleteIcon fontSize="small" />
  </IconButton>
);

export default DeleteButton;
